import { uniqueId } from "@/views/zhiji/js/common/util.js";
import { ParamError } from "@/views/zhiji/js/common/errors.js";
import i18n from "@/i18n";

export default {
    widgetName: "Video",
    serverType: "singleVideo",
    initContent() {
        return {
            uId: uniqueId(),
            updateState: "add",
            wtType: "Video",
            name: ""
        };
    },
    checkContent(content) {
        if (!content.name || !content.cardImage) {
            throw new ParamError(i18n.t("zhiji.answer.videoWidgeEmpty"));
        }
    },
    server2Client(content) {
        return {
            uId: uniqueId(),
            wtType: "Video",
            updateState: "",
            resourceId: content.resource_id,
            cardImage: content.image || "", //视频缩略图，封面图
            name: content.name || "", //视频标题
            url: content.url || "", //视频连接
            videoId: content.video_id || "", //视频id
            videoTime: content.vt || "0", //视频时长，单位s
            videoSize: content.vsize || "0"
        };
    },
    client2Server(content) {
        return {
            type: "video",
            resource_id: content.resourceId,
            image: content.cardImage, //视频缩略图，封面图
            name: content.name, //视频标题
            url: content.url, //视频连接
            video_id: content.videoId, //视频id
            vt: content.videoTime + "", //视频时长，单位s
            vsize: content.videoSize + ""
        };
    }
};
